import request from '@/utils/request'

/**
 * 技师相关API
 */
let PaymentApi = {
  // /**
  //  * 获取技师列表
  //  * @param {Object} data - 请求参数
  //  * @param {Function} errorback - 错误回调
  //  * @returns {Promise}
  //  */
  // getList(data, errorback) {
  //   return request._post('/supplier/payment.payment/index', data, errorback);
  // },
  /**
   * 测试支付接口
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  createCheckoutSessionTest(data, errorback) {
    return request._post('/supplier/payment.payment/createCheckoutSessionTest', data, errorback);
  },

}

export default PaymentApi;



// WEBPACK FOOTER //
// ./src/api/payment/payment.js